import { Navigate } from 'react-router-dom';
import { useAppContext } from '../Context/AppContext';
import { getAuthenticatedHomePath } from '../Shared/homePath';

const SuperuserRoute = ({ children }) => {
	const { state } = useAppContext();

	if (!state.user.id) {
		return null;
	}

	if (!state.user.isSuperuser) {
		return <Navigate to={getAuthenticatedHomePath(state.user)} replace />;
	}

	return children;
};

export default SuperuserRoute;
